<template>
  <v-layout row wrap align-center justify-center>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <h1>{{ meta.title }}</h1>
        </v-card-title>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  computed: {
    meta() {
      return this.$route.meta;
    },
  },
};
</script>
